// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.3_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.3_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.3_webpack@5.99.9/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@disy/cadenza-icons/chevron-down.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer components {
  /*
   * We cannot easily remove these global variables, because they're used in multiple places.
   *
   * PLEASE DO NOT ADD MORE VARIABLES HERE! (Unless they're used in multiple places, too.)
   */
  :root {
    --button-size-m: var(--space-8);
    --button-size-s: var(--space-6);
    --button-size-xs: var(--space-5);
  }

  @media (pointer: coarse) {
    :root {
      --button-size-m: calc(11 * var(--space-1));
      --button-size-s: var(--space-8);
      --button-size-xs: var(--space-6);
    }
  }

  :is(.white-bg, .light-bg),
  .button:where(:not(:is(.white-bg, .light-bg, .dark-bg) .button)) {
    --button-bg: var(--color-gray-01);
    --button-bg-active: var(--color-gray-02);
    --button-bg-disabled: var(--color-gray-01);
    --button-bg-hover: var(--color-gray-03);
    --button-bg-pressed: var(--primary-color);
    --button-bg-pressed-active: var(--primary-color-darken-15);
    --button-bg-pressed-disabled: var(--disabled-color);
    --button-bg-pressed-hover: var(--primary-color-darken-30);
    --button-border-color: var(--color-gray-03);
    --button-color: var(--color-gray-08);
    --button-color-pressed: var(--color-white-09);
    --button-color-pressed-disabled: var(--color-gray-01);

    /* Primary */
    --button-primary-bg: var(--primary-color);
    --button-primary-bg-active: var(--primary-color-darken-15);
    --button-primary-bg-disabled: var(--color-gray-04);
    --button-primary-bg-hover: var(--primary-color-darken-30);
    --button-primary-border-color: transparent;
    --button-primary-color: var(--color-white-09);
    --button-primary-color-disabled: var(--color-gray-01);

    /* Borderless */
    --button-borderless-bg: transparent;
    --button-borderless-bg-active: var(--color-gray-01);
    --button-borderless-bg-disabled: transparent;
    --button-borderless-bg-hover: var(--color-gray-02);
    --button-borderless-border-color: transparent;
    --button-borderless-color: var(--color-gray-06);

    /* Link */
    --button-link-color: var(--link-color);

    /* Error */
    --button-error-bg: var(--color-error-02);
    --button-error-bg-active: var(--color-error-03);
    --button-error-bg-hover: var(--color-error-04);
    --button-error-border-color: var(--color-error-04);
    --button-error-color: var(--color-error-07);

    /* Warning */
    --button-warning-bg: var(--color-warning-01);
    --button-warning-bg-active: var(--color-warning-02);
    --button-warning-bg-hover: var(--color-warning-03);
    --button-warning-border-color: var(--color-warning-03);
    --button-warning-color: var(--color-gray-08);

    /* Info */
    --button-info-bg: var(--color-info-02);
    --button-info-bg-active: var(--color-info-03);
    --button-info-bg-hover: var(--color-info-04);
    --button-info-border-color: var(--color-info-04);
    --button-info-color: var(--color-info-07);

    /* Success */
    --button-success-bg: var(--color-success-02);
    --button-success-bg-active: var(--color-success-03);
    --button-success-bg-hover: var(--color-success-04);
    --button-success-border-color: var(--color-success-04);
    --button-success-color: var(--color-success-07);
  }

  .light-bg {
    --button-bg: var(--color-white-09);
    --button-bg-disabled: var(--color-gray-02);
  }

  .dark-bg {
    --button-bg: var(--color-white-01);
    --button-bg-active: var(--color-white-02);
    --button-bg-disabled: var(--color-white-01);
    --button-bg-hover: var(--color-white-03);
    --button-bg-pressed: var(--color-white-08);
    --button-bg-pressed-active: var(--color-white-07);
    --button-bg-pressed-disabled: var(--color-white-04);
    --button-bg-pressed-hover: var(--color-white-09);
    --button-border-color: var(--color-white-03);
    --button-color: var(--color-white-08);
    --button-color-pressed: var(--primary-color-darken-15);
    --button-color-pressed-disabled: var(--color-white-04);

    /* Primary */
    --button-primary-bg: var(--color-white-08);
    --button-primary-bg-active: var(--color-white-07);
    --button-primary-bg-disabled: var(--color-white-04);
    --button-primary-bg-hover: var(--color-white-09);
    --button-primary-color: var(--primary-color-darken-15);
    --button-primary-color-disabled: var(--color-gray-04);

    /* Borderless */
    --button-borderless-bg-active: var(--color-white-01);
    --button-borderless-bg-hover: var(--color-white-02);
    --button-borderless-color: var(--color-white-07);

    /* Error */
    --button-error-bg: var(--color-error-06);
    --button-error-bg-active: var(--color-error-07);
    --button-error-bg-hover: var(--color-error-05);

    /* Warning */
    --button-warning-bg: var(--color-warning-06);
    --button-warning-bg-active: var(--color-warning-07);
    --button-warning-bg-hover: var(--color-warning-05);

    /* Info */
    --button-info-bg: var(--color-info-06);
    --button-info-bg-active: var(--color-info-07);
    --button-info-bg-hover: var(--color-info-05);

    /* Success */
    --button-success-bg: var(--color-success-06);
    --button-success-bg-active: var(--color-success-07);
    --button-success-bg-hover: var(--color-success-05);
  }

  .button {
    --button-color-disabled: var(--disabled-color);

    align-items: center;
    appearance: none;
    background-color: var(--button-bg);
    border: 1px solid var(--button-border-color);
    border-radius: 2px;
    color: var(--button-color);
    cursor: pointer;
    display: inline-flex;
    flex-shrink: 0;
    font-family: var(--default-font-family);
    font-size: var(--default-font-size);
    justify-content: center;
    text-align: center;
    text-decoration: none;
    transition: background-color var(--default-transition),
    outline var(--default-transition),
    color var(--default-transition);
    -webkit-user-select: none;
            user-select: none;
    white-space: nowrap;
    width: fit-content; /* Do not stretch in column flex layouts */
  }

    .button[aria-pressed='true'] {
      --button-bg: var(--button-bg-pressed);
      --button-bg-active: var(--button-bg-pressed-active);
      --button-bg-disabled: var(--button-bg-pressed-disabled);
      --button-bg-hover: var(--button-bg-pressed-hover);
      --button-color: var(--button-color-pressed);
      --button-color-disabled: var(--button-color-pressed-disabled);
    }

    .button:focus {
      outline: var(--is-not-keynav, var(--default-outline));
      outline-offset: var(--default-outline-offset);
    }

    .button:hover {
      --button-bg: var(--button-bg-hover);
    }

    /* If a button is both, pressed and enabled, then the pressed styles should win. */
    .button:is(:active,[aria-expanded='true']:where(:not([aria-pressed='true']))) {
      --button-bg: var(--button-bg-active);
    }

    .button:is(:disabled,[aria-disabled="true"]) {
      --button-bg: var(--button-bg-disabled);
      --button-border-color: transparent;
      --button-color: var(--button-color-disabled);

      cursor: initial;
    }

    .button:where(:not(.button-icon,.button-round)) > .d-icon:first-child {
      margin-right: var(--space-05);
    }

    .button .button--label {
      cursor: inherit;
    }

    .button .button--label + .d-icon {
      margin-left: var(--space-1);
    }

  /*********
   * Sizes *
   *********/

  /* Default Size (M) */
  .button {
    --button-size: var(--button-size-m);
    --button-icon-size: var(--space-5);
    --button-padding: var(--space-3);

    height: var(--button-size);
    line-height: var(--button-size);
    min-width: calc(var(--button-size) * 2);
    padding: 0 var(--button-padding);
  }

    .button .d-icon {
      --icon-stroke-width: initial;
    }

    .button :is(.d-icon,.d-icon-stack):not(.d-icon-xxs,.d-icon-xs,.d-icon-s,.d-icon-l,.d-icon-xl) {
      width: var(--button-icon-size);
    }

  .button-s {
    --button-size: var(--button-size-s);
    --button-icon-size: var(--space-5); /* This value needs to be repeated, because .button-s is used without .button for icon toggles. */
    --button-padding: var(--space-2);
  }

  .button-xs {
    --button-size: var(--button-size-xs);
    --button-size-touch: calc(100% + 6px);
    --button-icon-size: calc(var(--button-size) - var(--space-1));
    --button-padding: var(--space-1);

    font-size: var(--small-font-size);
    position: relative;

    /* increase the size of the button's touch target without increasing the visual size */
  }
    .button-xs::before {
      content: '';
      display: block;
      height: var(--button-size-touch);
      position: absolute;
      width: var(--button-size-touch);
    }

  /* Not an official button size */
  .button-xxs {
    --button-size: var(--space-4);
    --button-icon-size: var(--space-3);
    --button-padding: var(--space-05);
  }

  /***************
   * Icon Button *
   ***************/
  .button-icon {
    --button-padding: var(--space-1);

    min-width: 0;
    width: var(--button-size);
  }

    .button-icon.button-s {
      --button-padding: 0;
    }

    .button-icon.button-xs {
      --button-padding: var(--space-025);
    }

    .button-icon.button-xxs {
      --button-padding: var(--space-05);
    }

  /************************
   * Button with dropdown *
   ************************/
  .button-with-dropdown {
    --dropdown-arrow-width: var(--icon-size-xs);
  }

    .button-with-dropdown::after {
      aspect-ratio: 1;
      background-color: currentColor;
      content: '';
      display: inline-block;
      mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center no-repeat;
      width: var(--dropdown-arrow-width);
    }

      :not(.button-icon) :is(.button-with-dropdown::after) {
        margin-left: var(--space-1);
      }

  .button-icon.button-with-dropdown {
    width: calc(var(--button-size) + var(--dropdown-arrow-width)); /* Adds space for the dropdown */
  }

  /************
   * Variants *
   ************/

  /* Primary */
  .button-primary {
    --button-bg: var(--button-primary-bg);
    --button-bg-active: var(--button-primary-bg-active);
    --button-bg-disabled: var(--button-primary-bg-disabled);
    --button-bg-hover: var(--button-primary-bg-hover);
    --button-border-color: var(--button-primary-border-color);
    --button-color: var(--button-primary-color);
    --button-color-disabled: var(--button-primary-color-disabled);
  }

  /* Borderless */
  .button-borderless, .button-link, .button-round {
    --button-bg: var(--button-borderless-bg);
    --button-bg-active: var(--button-borderless-bg-active);
    --button-bg-disabled: var(--button-borderless-bg-disabled);
    --button-bg-hover: var(--button-borderless-bg-hover);
    --button-border-color: var(--button-borderless-border-color);
    --button-color: var(--button-borderless-color);

    min-width: var(--button-size);
  }

    :is(.button-borderless,.button-link,.button-round):not(.button-icon) {
      --button-padding: var(--space-05);
    }

  /* Error */
  .button-error {
    --button-bg: var(--button-error-bg);
    --button-bg-active: var(--button-error-bg-active);
    --button-bg-hover: var(--button-error-bg-hover);
    --button-border-color: var(--button-error-border-color);
    --button-color: var(--button-error-color);
  }

  /* Warning */
  .button-warning {
    --button-bg: var(--button-warning-bg);
    --button-bg-active: var(--button-warning-bg-active);
    --button-bg-hover: var(--button-warning-bg-hover);
    --button-border-color: var(--button-warning-border-color);
    --button-color: var(--button-warning-color);
  }

  /* Info */
  .button-info {
    --button-bg: var(--button-info-bg);
    --button-bg-active: var(--button-info-bg-active);
    --button-bg-hover: var(--button-info-bg-hover);
    --button-border-color: var(--button-info-border-color);
    --button-color: var(--button-info-color);
  }

  /* Success */
  .button-success {
    --button-bg: var(--button-success-bg);
    --button-bg-active: var(--button-success-bg-active);
    --button-bg-hover: var(--button-success-bg-hover);
    --button-border-color: var(--button-success-border-color);
    --button-color: var(--button-success-color);
  }

  /* Link (as special case of the borderless variant) */
  .button-link, .button-round {
    --button-color: var(--button-link-color);
    --button-padding: var(--space-05);
  }

  /* Round (a special case of the link variant) */
  .button-round {
    --button-size: var(--space-12);
    --button-bg: var(--color-white-09);

    border-radius: 50%;
    box-shadow: var(--default-box-shadow);
    min-width: 0;
    width: var(--button-size);
  }

    .button-round.button-s {
      --button-size: calc(9 * var(--space-1));
    }
}
`, "",{"version":3,"sources":["webpack://./packages/ui/src/button/button.css"],"names":[],"mappings":"AAAA;EACE;;;;IAIE;EACF;IACE,+BAA+B;IAC/B,+BAA+B;IAC/B,gCAAgC;EAClC;;EAEA;IACE;MACE,0CAA0C;MAC1C,+BAA+B;MAC/B,gCAAgC;IAClC;EACF;;EAEA;;IAEE,iCAAiC;IACjC,wCAAwC;IACxC,0CAA0C;IAC1C,uCAAuC;IACvC,yCAAyC;IACzC,0DAA0D;IAC1D,mDAAmD;IACnD,yDAAyD;IACzD,2CAA2C;IAC3C,oCAAoC;IACpC,6CAA6C;IAC7C,qDAAqD;;IAErD,YAAY;IACZ,yCAAyC;IACzC,0DAA0D;IAC1D,kDAAkD;IAClD,yDAAyD;IACzD,0CAA0C;IAC1C,6CAA6C;IAC7C,qDAAqD;;IAErD,eAAe;IACf,mCAAmC;IACnC,mDAAmD;IACnD,4CAA4C;IAC5C,kDAAkD;IAClD,6CAA6C;IAC7C,+CAA+C;;IAE/C,SAAS;IACT,sCAAsC;;IAEtC,UAAU;IACV,wCAAwC;IACxC,+CAA+C;IAC/C,8CAA8C;IAC9C,kDAAkD;IAClD,2CAA2C;;IAE3C,YAAY;IACZ,4CAA4C;IAC5C,mDAAmD;IACnD,kDAAkD;IAClD,sDAAsD;IACtD,4CAA4C;;IAE5C,SAAS;IACT,sCAAsC;IACtC,6CAA6C;IAC7C,4CAA4C;IAC5C,gDAAgD;IAChD,yCAAyC;;IAEzC,YAAY;IACZ,4CAA4C;IAC5C,mDAAmD;IACnD,kDAAkD;IAClD,sDAAsD;IACtD,+CAA+C;EACjD;;EAEA;IACE,kCAAkC;IAClC,0CAA0C;EAC5C;;EAEA;IACE,kCAAkC;IAClC,yCAAyC;IACzC,2CAA2C;IAC3C,wCAAwC;IACxC,0CAA0C;IAC1C,iDAAiD;IACjD,mDAAmD;IACnD,gDAAgD;IAChD,4CAA4C;IAC5C,qCAAqC;IACrC,sDAAsD;IACtD,sDAAsD;;IAEtD,YAAY;IACZ,0CAA0C;IAC1C,iDAAiD;IACjD,mDAAmD;IACnD,gDAAgD;IAChD,sDAAsD;IACtD,qDAAqD;;IAErD,eAAe;IACf,oDAAoD;IACpD,mDAAmD;IACnD,gDAAgD;;IAEhD,UAAU;IACV,wCAAwC;IACxC,+CAA+C;IAC/C,8CAA8C;;IAE9C,YAAY;IACZ,4CAA4C;IAC5C,mDAAmD;IACnD,kDAAkD;;IAElD,SAAS;IACT,sCAAsC;IACtC,6CAA6C;IAC7C,4CAA4C;;IAE5C,YAAY;IACZ,4CAA4C;IAC5C,mDAAmD;IACnD,kDAAkD;EACpD;;EAEA;IACE,8CAA8C;;IAE9C,mBAAmB;IACnB,gBAAgB;IAChB,kCAAkC;IAClC,4CAA4C;IAC5C,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,oBAAoB;IACpB,cAAc;IACd,uCAAuC;IACvC,mCAAmC;IACnC,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;IACrB;;mCAE+B;IAC/B,yBAAiB;YAAjB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB,EAAE,0CAA0C;EA4ChE;;IA1CE;MACE,qCAAqC;MACrC,mDAAmD;MACnD,uDAAuD;MACvD,iDAAiD;MACjD,2CAA2C;MAC3C,6DAA6D;IAC/D;;IAEA;MACE,qDAAqD;MACrD,6CAA6C;IAC/C;;IAEA;MACE,mCAAmC;IACrC;;IAEA,kFAAkF;IAClF;MACE,oCAAoC;IACtC;;IAEA;MACE,sCAAsC;MACtC,kCAAkC;MAClC,4CAA4C;;MAE5C,eAAe;IACjB;;IAEA;MACE,6BAA6B;IAC/B;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,2BAA2B;IAC7B;;EAGF;;YAEU;;EAEV,qBAAqB;EACrB;IACE,mCAAmC;IACnC,kCAAkC;IAClC,gCAAgC;;IAEhC,0BAA0B;IAC1B,+BAA+B;IAC/B,uCAAuC;IACvC,gCAAgC;EASlC;;IAPE;MACE,4BAA4B;IAC9B;;IAEA;MACE,8BAA8B;IAChC;;EAGF;IACE,mCAAmC;IACnC,kCAAkC,EAAE,iGAAiG;IACrI,gCAAgC;EAClC;;EAEA;IACE,oCAAoC;IACpC,qCAAqC;IACrC,6DAA6D;IAC7D,gCAAgC;;IAEhC,iCAAiC;IACjC,kBAAkB;;IAElB,sFAAsF;EAQxF;IAPE;MACE,WAAW;MACX,cAAc;MACd,gCAAgC;MAChC,kBAAkB;MAClB,+BAA+B;IACjC;;EAGF,gCAAgC;EAChC;IACE,6BAA6B;IAC7B,kCAAkC;IAClC,iCAAiC;EACnC;;EAEA;;kBAEgB;EAChB;IACE,gCAAgC;;IAEhC,YAAY;IACZ,yBAAyB;EAa3B;;IAXE;MACE,mBAAmB;IACrB;;IAEA;MACE,kCAAkC;IACpC;;IAEA;MACE,iCAAiC;IACnC;;EAGF;;2BAEyB;EACzB;IACE,2CAA2C;EAc7C;;IAZE;MACE,eAAe;MACf,8BAA8B;MAC9B,WAAW;MACX,qBAAqB;MACrB,8DAAmE;MACnE,kCAAkC;IAKpC;;MAHE;QACE,2BAA2B;MAC7B;;EAIJ;IACE,6DAA6D,EAAE,gCAAgC;EACjG;;EAEA;;eAEa;;EAEb,YAAY;EACZ;IACE,qCAAqC;IACrC,mDAAmD;IACnD,uDAAuD;IACvD,iDAAiD;IACjD,yDAAyD;IACzD,2CAA2C;IAC3C,6DAA6D;EAC/D;;EAEA,eAAe;EACf;IACE,wCAAwC;IACxC,sDAAsD;IACtD,0DAA0D;IAC1D,oDAAoD;IACpD,4DAA4D;IAC5D,8CAA8C;;IAE9C,6BAA6B;EAK/B;;IAHE;MACE,iCAAiC;IACnC;;EAGF,UAAU;EACV;IACE,mCAAmC;IACnC,iDAAiD;IACjD,+CAA+C;IAC/C,uDAAuD;IACvD,yCAAyC;EAC3C;;EAEA,YAAY;EACZ;IACE,qCAAqC;IACrC,mDAAmD;IACnD,iDAAiD;IACjD,yDAAyD;IACzD,2CAA2C;EAC7C;;EAEA,SAAS;EACT;IACE,kCAAkC;IAClC,gDAAgD;IAChD,8CAA8C;IAC9C,sDAAsD;IACtD,wCAAwC;EAC1C;;EAEA,YAAY;EACZ;IACE,qCAAqC;IACrC,mDAAmD;IACnD,iDAAiD;IACjD,yDAAyD;IACzD,2CAA2C;EAC7C;;EAEA,qDAAqD;EACrD;IACE,wCAAwC;IACxC,iCAAiC;EACnC;;EAEA,+CAA+C;EAC/C;IACE,8BAA8B;IAC9B,kCAAkC;;IAElC,kBAAkB;IAClB,qCAAqC;IACrC,YAAY;IACZ,yBAAyB;EAK3B;;IAHE;MACE,uCAAuC;IACzC;AAEJ","sourcesContent":["@layer components {\n  /*\n   * We cannot easily remove these global variables, because they're used in multiple places.\n   *\n   * PLEASE DO NOT ADD MORE VARIABLES HERE! (Unless they're used in multiple places, too.)\n   */\n  :root {\n    --button-size-m: var(--space-8);\n    --button-size-s: var(--space-6);\n    --button-size-xs: var(--space-5);\n  }\n\n  @media (--touch) {\n    :root {\n      --button-size-m: calc(11 * var(--space-1));\n      --button-size-s: var(--space-8);\n      --button-size-xs: var(--space-6);\n    }\n  }\n\n  :is(.white-bg, .light-bg),\n  .button:where(:not(:is(.white-bg, .light-bg, .dark-bg) .button)) {\n    --button-bg: var(--color-gray-01);\n    --button-bg-active: var(--color-gray-02);\n    --button-bg-disabled: var(--color-gray-01);\n    --button-bg-hover: var(--color-gray-03);\n    --button-bg-pressed: var(--primary-color);\n    --button-bg-pressed-active: var(--primary-color-darken-15);\n    --button-bg-pressed-disabled: var(--disabled-color);\n    --button-bg-pressed-hover: var(--primary-color-darken-30);\n    --button-border-color: var(--color-gray-03);\n    --button-color: var(--color-gray-08);\n    --button-color-pressed: var(--color-white-09);\n    --button-color-pressed-disabled: var(--color-gray-01);\n\n    /* Primary */\n    --button-primary-bg: var(--primary-color);\n    --button-primary-bg-active: var(--primary-color-darken-15);\n    --button-primary-bg-disabled: var(--color-gray-04);\n    --button-primary-bg-hover: var(--primary-color-darken-30);\n    --button-primary-border-color: transparent;\n    --button-primary-color: var(--color-white-09);\n    --button-primary-color-disabled: var(--color-gray-01);\n\n    /* Borderless */\n    --button-borderless-bg: transparent;\n    --button-borderless-bg-active: var(--color-gray-01);\n    --button-borderless-bg-disabled: transparent;\n    --button-borderless-bg-hover: var(--color-gray-02);\n    --button-borderless-border-color: transparent;\n    --button-borderless-color: var(--color-gray-06);\n\n    /* Link */\n    --button-link-color: var(--link-color);\n\n    /* Error */\n    --button-error-bg: var(--color-error-02);\n    --button-error-bg-active: var(--color-error-03);\n    --button-error-bg-hover: var(--color-error-04);\n    --button-error-border-color: var(--color-error-04);\n    --button-error-color: var(--color-error-07);\n\n    /* Warning */\n    --button-warning-bg: var(--color-warning-01);\n    --button-warning-bg-active: var(--color-warning-02);\n    --button-warning-bg-hover: var(--color-warning-03);\n    --button-warning-border-color: var(--color-warning-03);\n    --button-warning-color: var(--color-gray-08);\n\n    /* Info */\n    --button-info-bg: var(--color-info-02);\n    --button-info-bg-active: var(--color-info-03);\n    --button-info-bg-hover: var(--color-info-04);\n    --button-info-border-color: var(--color-info-04);\n    --button-info-color: var(--color-info-07);\n\n    /* Success */\n    --button-success-bg: var(--color-success-02);\n    --button-success-bg-active: var(--color-success-03);\n    --button-success-bg-hover: var(--color-success-04);\n    --button-success-border-color: var(--color-success-04);\n    --button-success-color: var(--color-success-07);\n  }\n\n  .light-bg {\n    --button-bg: var(--color-white-09);\n    --button-bg-disabled: var(--color-gray-02);\n  }\n\n  .dark-bg {\n    --button-bg: var(--color-white-01);\n    --button-bg-active: var(--color-white-02);\n    --button-bg-disabled: var(--color-white-01);\n    --button-bg-hover: var(--color-white-03);\n    --button-bg-pressed: var(--color-white-08);\n    --button-bg-pressed-active: var(--color-white-07);\n    --button-bg-pressed-disabled: var(--color-white-04);\n    --button-bg-pressed-hover: var(--color-white-09);\n    --button-border-color: var(--color-white-03);\n    --button-color: var(--color-white-08);\n    --button-color-pressed: var(--primary-color-darken-15);\n    --button-color-pressed-disabled: var(--color-white-04);\n\n    /* Primary */\n    --button-primary-bg: var(--color-white-08);\n    --button-primary-bg-active: var(--color-white-07);\n    --button-primary-bg-disabled: var(--color-white-04);\n    --button-primary-bg-hover: var(--color-white-09);\n    --button-primary-color: var(--primary-color-darken-15);\n    --button-primary-color-disabled: var(--color-gray-04);\n\n    /* Borderless */\n    --button-borderless-bg-active: var(--color-white-01);\n    --button-borderless-bg-hover: var(--color-white-02);\n    --button-borderless-color: var(--color-white-07);\n\n    /* Error */\n    --button-error-bg: var(--color-error-06);\n    --button-error-bg-active: var(--color-error-07);\n    --button-error-bg-hover: var(--color-error-05);\n\n    /* Warning */\n    --button-warning-bg: var(--color-warning-06);\n    --button-warning-bg-active: var(--color-warning-07);\n    --button-warning-bg-hover: var(--color-warning-05);\n\n    /* Info */\n    --button-info-bg: var(--color-info-06);\n    --button-info-bg-active: var(--color-info-07);\n    --button-info-bg-hover: var(--color-info-05);\n\n    /* Success */\n    --button-success-bg: var(--color-success-06);\n    --button-success-bg-active: var(--color-success-07);\n    --button-success-bg-hover: var(--color-success-05);\n  }\n\n  .button {\n    --button-color-disabled: var(--disabled-color);\n\n    align-items: center;\n    appearance: none;\n    background-color: var(--button-bg);\n    border: 1px solid var(--button-border-color);\n    border-radius: 2px;\n    color: var(--button-color);\n    cursor: pointer;\n    display: inline-flex;\n    flex-shrink: 0;\n    font-family: var(--default-font-family);\n    font-size: var(--default-font-size);\n    justify-content: center;\n    text-align: center;\n    text-decoration: none;\n    transition: background-color var(--default-transition),\n    outline var(--default-transition),\n    color var(--default-transition);\n    user-select: none;\n    white-space: nowrap;\n    width: fit-content; /* Do not stretch in column flex layouts */\n\n    &[aria-pressed='true'] {\n      --button-bg: var(--button-bg-pressed);\n      --button-bg-active: var(--button-bg-pressed-active);\n      --button-bg-disabled: var(--button-bg-pressed-disabled);\n      --button-bg-hover: var(--button-bg-pressed-hover);\n      --button-color: var(--button-color-pressed);\n      --button-color-disabled: var(--button-color-pressed-disabled);\n    }\n\n    &:focus {\n      outline: var(--is-not-keynav, var(--default-outline));\n      outline-offset: var(--default-outline-offset);\n    }\n\n    &:hover {\n      --button-bg: var(--button-bg-hover);\n    }\n\n    /* If a button is both, pressed and enabled, then the pressed styles should win. */\n    &:is(:active, [aria-expanded='true']:where(:not([aria-pressed='true']))) {\n      --button-bg: var(--button-bg-active);\n    }\n\n    &:is(:disabled, [aria-disabled=\"true\"]) {\n      --button-bg: var(--button-bg-disabled);\n      --button-border-color: transparent;\n      --button-color: var(--button-color-disabled);\n\n      cursor: initial;\n    }\n\n    &:where(:not(.button-icon, .button-round)) > .d-icon:first-child {\n      margin-right: var(--space-05);\n    }\n\n    & .button--label {\n      cursor: inherit;\n    }\n\n    & .button--label + .d-icon {\n      margin-left: var(--space-1);\n    }\n  }\n\n  /*********\n   * Sizes *\n   *********/\n\n  /* Default Size (M) */\n  .button {\n    --button-size: var(--button-size-m);\n    --button-icon-size: var(--space-5);\n    --button-padding: var(--space-3);\n\n    height: var(--button-size);\n    line-height: var(--button-size);\n    min-width: calc(var(--button-size) * 2);\n    padding: 0 var(--button-padding);\n\n    .d-icon {\n      --icon-stroke-width: initial;\n    }\n\n    :is(.d-icon, .d-icon-stack):not(.d-icon-xxs, .d-icon-xs, .d-icon-s, .d-icon-l, .d-icon-xl) {\n      width: var(--button-icon-size);\n    }\n  }\n\n  .button-s {\n    --button-size: var(--button-size-s);\n    --button-icon-size: var(--space-5); /* This value needs to be repeated, because .button-s is used without .button for icon toggles. */\n    --button-padding: var(--space-2);\n  }\n\n  .button-xs {\n    --button-size: var(--button-size-xs);\n    --button-size-touch: calc(100% + 6px);\n    --button-icon-size: calc(var(--button-size) - var(--space-1));\n    --button-padding: var(--space-1);\n\n    font-size: var(--small-font-size);\n    position: relative;\n\n    /* increase the size of the button's touch target without increasing the visual size */\n    &::before {\n      content: '';\n      display: block;\n      height: var(--button-size-touch);\n      position: absolute;\n      width: var(--button-size-touch);\n    }\n  }\n\n  /* Not an official button size */\n  .button-xxs {\n    --button-size: var(--space-4);\n    --button-icon-size: var(--space-3);\n    --button-padding: var(--space-05);\n  }\n\n  /***************\n   * Icon Button *\n   ***************/\n  .button-icon {\n    --button-padding: var(--space-1);\n\n    min-width: 0;\n    width: var(--button-size);\n\n    &.button-s {\n      --button-padding: 0;\n    }\n\n    &.button-xs {\n      --button-padding: var(--space-025);\n    }\n\n    &.button-xxs {\n      --button-padding: var(--space-05);\n    }\n  }\n\n  /************************\n   * Button with dropdown *\n   ************************/\n  .button-with-dropdown {\n    --dropdown-arrow-width: var(--icon-size-xs);\n\n    &::after {\n      aspect-ratio: 1;\n      background-color: currentColor;\n      content: '';\n      display: inline-block;\n      mask: url('~@disy/cadenza-icons/chevron-down.svg') center no-repeat;\n      width: var(--dropdown-arrow-width);\n\n      :not(.button-icon) & {\n        margin-left: var(--space-1);\n      }\n    }\n  }\n\n  .button-icon.button-with-dropdown {\n    width: calc(var(--button-size) + var(--dropdown-arrow-width)); /* Adds space for the dropdown */\n  }\n\n  /************\n   * Variants *\n   ************/\n\n  /* Primary */\n  .button-primary {\n    --button-bg: var(--button-primary-bg);\n    --button-bg-active: var(--button-primary-bg-active);\n    --button-bg-disabled: var(--button-primary-bg-disabled);\n    --button-bg-hover: var(--button-primary-bg-hover);\n    --button-border-color: var(--button-primary-border-color);\n    --button-color: var(--button-primary-color);\n    --button-color-disabled: var(--button-primary-color-disabled);\n  }\n\n  /* Borderless */\n  .button-borderless, .button-link, .button-round {\n    --button-bg: var(--button-borderless-bg);\n    --button-bg-active: var(--button-borderless-bg-active);\n    --button-bg-disabled: var(--button-borderless-bg-disabled);\n    --button-bg-hover: var(--button-borderless-bg-hover);\n    --button-border-color: var(--button-borderless-border-color);\n    --button-color: var(--button-borderless-color);\n\n    min-width: var(--button-size);\n\n    &:not(.button-icon) {\n      --button-padding: var(--space-05);\n    }\n  }\n\n  /* Error */\n  .button-error {\n    --button-bg: var(--button-error-bg);\n    --button-bg-active: var(--button-error-bg-active);\n    --button-bg-hover: var(--button-error-bg-hover);\n    --button-border-color: var(--button-error-border-color);\n    --button-color: var(--button-error-color);\n  }\n\n  /* Warning */\n  .button-warning {\n    --button-bg: var(--button-warning-bg);\n    --button-bg-active: var(--button-warning-bg-active);\n    --button-bg-hover: var(--button-warning-bg-hover);\n    --button-border-color: var(--button-warning-border-color);\n    --button-color: var(--button-warning-color);\n  }\n\n  /* Info */\n  .button-info {\n    --button-bg: var(--button-info-bg);\n    --button-bg-active: var(--button-info-bg-active);\n    --button-bg-hover: var(--button-info-bg-hover);\n    --button-border-color: var(--button-info-border-color);\n    --button-color: var(--button-info-color);\n  }\n\n  /* Success */\n  .button-success {\n    --button-bg: var(--button-success-bg);\n    --button-bg-active: var(--button-success-bg-active);\n    --button-bg-hover: var(--button-success-bg-hover);\n    --button-border-color: var(--button-success-border-color);\n    --button-color: var(--button-success-color);\n  }\n\n  /* Link (as special case of the borderless variant) */\n  .button-link, .button-round {\n    --button-color: var(--button-link-color);\n    --button-padding: var(--space-05);\n  }\n\n  /* Round (a special case of the link variant) */\n  .button-round {\n    --button-size: var(--space-12);\n    --button-bg: var(--color-white-09);\n\n    border-radius: 50%;\n    box-shadow: var(--default-box-shadow);\n    min-width: 0;\n    width: var(--button-size);\n\n    &.button-s {\n      --button-size: calc(9 * var(--space-1));\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
